<template>
  <div class="main-box">
    <el-form class="form-inline mg-tp-10" :inline="true" size="small">
      <el-form-item label="业绩统计到">
        <el-date-picker
            size="small"
            v-model="search.statistics_time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入会员ID/姓名/手机号" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="handleSearch()">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        ref="rfTable"
        border
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          prop="user_id"
          label="会员ID">
      </el-table-column>
      <el-table-column
          prop="name"
          label="昵称"
          align="center"
          min-width="120">
      </el-table-column>
      <el-table-column
          prop="avatar"
          label="头像"
          align="center"
          min-width="100">
        <template slot-scope="scope">
          <el-avatar :size="40" shape="square" :src="scope.row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
          min-width="120">
      </el-table-column>
      <el-table-column
          prop="grade_name"
          label="会员身份"
          align="left"
          min-width="120">
      </el-table-column>
      <el-table-column
          prop="commission"
          label="剩余业绩"
          align="left"
          min-width="120">
      </el-table-column>
      <el-table-column
          prop="statistics_commission"
          label="截至业绩"
          align="left"
          min-width="120">
      </el-table-column>
      <el-table-column
          prop="tweeter"
          label="上级"
          align="left"
          min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.tweeter" style="display: flex; align-items: center">
            <el-avatar :size="40" shape="square" :src="scope.row.tweeter.avatar" class="mg-rt-10"></el-avatar>
            <div>{{scope.row.tweeter.name}}<br>{{scope.row.tweeter.user_id}}</div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="注册时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="80">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showCommissionBox(scope.row)">发放业绩</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
    <el-dialog
        title="发放业绩"
        :visible.sync="showCommissionDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="500px">
      <el-form :model="commissionInfo" label-position="right" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
        <el-form-item label="会员">
          {{ commissionInfo.name }}
        </el-form-item>
        <el-form-item label="剩余业绩">
          {{ commissionInfo.commission }}
        </el-form-item>
        <el-form-item label="发放金额" prop="sum">
          <el-input v-model="commissionInfo.sum" placeholder="请输入金额"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="commissionInfo.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCommission">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      source_domain: this.config.SOURCE_DOMAIN,
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        keywords: '',
        statistics_time: ''
      },
      tableData: [],
      showCommissionDialog: false,
      commissionInfo: {
        id: 0,
        type: 5,
        name: '',
        commission: '',
        sum: '',
        remark: ''
      }
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  computed: {},
  methods: {
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        statistics_time: that.search.statistics_time,
      }
      this.$api.order.tradeIndex(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    showCommissionBox(row) {
      this.commissionInfo.id = row.id
      this.commissionInfo.type = 5
      this.commissionInfo.name = row.name
      this.commissionInfo.commission = row.commission
      this.commissionInfo.sum = ''
      this.commissionInfo.remark = ''
      this.showCommissionDialog = true
    },
    saveCommission() {
      if(this.commissionInfo.sum == '') {
        this.fail('请填写金额')
        return false
      }
      if(Number(this.commissionInfo.sum) <= 0) {
        this.fail('金额必须大于0')
        return false
      }
      if(Number(this.commissionInfo.sum) > Number(this.commissionInfo.commission)) {
        this.fail('发放金额不能大于剩余业绩')
        return false
      }
      if(this.commissionInfo.remark.trim() == '') {
        this.fail('请填写备注')
        return false
      }
      var param = {
        id: this.commissionInfo.id,
        type: 5,
        sum: this.commissionInfo.sum,
        remark: this.commissionInfo.remark
      }
      this.$api.member.memberCommissionUpda(param, res => {
        if(res.errcode==0) {
          this.showCommissionDialog = false
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
